import { deepClone } from '../utils/index.js';

function copyState(state) {
    return deepClone(state);
}

export { copyState };
